export const GET_PROJECTS_LIST = "get_projects_list";
export const GET_PROJECT_DATA = "get_project_data";
export const CREATE_PROJECT = "create_project";
export const EDIT_PROJECT = "edit_project";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const DELETE_PROJECT = "delete_project";
export const ERROR = "error";
export const YEAR_LIST = "year_list";
export const GET_AVAILABLE_CONSULTANTS = "get_available_consultants";
export const PROJECT_PLANS_FOR_YEAR = "project_plans_for_year";
export const INVOICES_DATA = "invoices_data";
export const BUILD_INVOICE = "build_invoice";
export const ACTIVITIES_DATA = "activities_data";
export const FILTERED_INVOICES = "filtered_invoices";
export const GET_FOROWN_LIST = "get_for_own_list";
export const GET_FOROTHER_LIST = "get_for_other_list";
export const LOGIN_ERROR = "login_error";
export const GET_USER_FOR_PM = "get_user_for_pm";
export const COMPARE_LIST = "compare_list";
